import React from 'react'
import GlobalCampaign from '../../global/campaigns'
import { deleteCampaignFalabella, getListCampaignFalabella, sendCampaignFalabella } from '../../../../hooks/api/campaigns'

export default function CampaignFalabella() {
  return (
    <>
        <GlobalCampaign 
            name={'Falabella'} 
            sendCampaignFn={sendCampaignFalabella} 
            deleteCampaignFn={deleteCampaignFalabella}
            getListFn={getListCampaignFalabella}
        />
    </>
  )
}
